import { NgModule, ModuleWithProviders, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceOfflineComponent } from './views/service-offline/service-offline.component';
import { ResponseErrorComponent } from './views/response-error/response-error.component';
import { ActionBusyIndicatorComponent } from './action-busy-indicator.component';
import { AlertComponent } from './views/alert/alert.component';
import { ConfirmContentComponent } from './modal-confirm/default-content/confirm-content.component';
import { ConfirmDiscardUnsavedChangesContentComponent } from './modal-confirm/confirm-discard-unsaved-changes-content/confirm-discard-unsaved-changes-content.component';
import { ControlErrorComponent } from './form-element-errors/control-error/control-error.component';
import { ControlErrorContainerDirective } from './form-element-errors/control-error-container.directive';
import { ControlsErrorsDirective } from './form-element-errors/controls-errors.directive';
import { FormSubmitDirective } from './form-element-errors/form-submit.directive';
import { ModalConfirmDirective } from './modal-confirm/modal-confirm.directive';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { ModalConfirmConfig } from './modal-confirm/default-content.config';
import { SessionTimeoutDirective } from './directives/session-timeout.directive';
import { NgbModule, NgbNav, NgbNavItem, NgbNavLink, NgbNavContent, NgbNavOutlet, NgbDropdownMenu, NgbDropdown, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Format24HourDatePipe } from './pipes/date-pipes';
import { UrlNotFoundComponent } from './views/url-not-found/url-not-found.component';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule
    ],
    declarations: [
        ActionBusyIndicatorComponent,
        AlertComponent,
        SessionTimeoutDirective,
        ConfirmContentComponent,
        ConfirmDiscardUnsavedChangesContentComponent,
        ControlErrorComponent,
        ControlErrorContainerDirective,
        ControlsErrorsDirective,
        FormSubmitDirective,
        ModalConfirmDirective,
        ModalConfirmComponent,
        ResponseErrorComponent,
        ServiceOfflineComponent,

        Format24HourDatePipe,

        UrlNotFoundComponent
    ],
    exports: [
        ActionBusyIndicatorComponent,
        AlertComponent,
        ControlsErrorsDirective,
        ControlErrorContainerDirective,
        ConfirmDiscardUnsavedChangesContentComponent,
        FormSubmitDirective,
        Format24HourDatePipe,
        ModalConfirmDirective,
        ModalConfirmComponent,
        ResponseErrorComponent,
        ServiceOfflineComponent,
        SessionTimeoutDirective,
        CommonModule,
        HttpClientModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgbNav,
        NgbNavItem,
        NgbNavLink,
        NgbNavContent,
        NgbNavOutlet,

        UrlNotFoundComponent
    ],
    entryComponents:
    [
        ConfirmContentComponent,
        ConfirmDiscardUnsavedChangesContentComponent,
        ControlErrorComponent
    ],
    providers: [
    ]
})
export class SharedComponentsModule {
    static forRoot(config: any): ModuleWithProviders<SharedComponentsModule> {
        return {
            ngModule: SharedComponentsModule,
            providers: [
                ModalConfirmConfig, { provide: 'ModalConfirmConfig', useValue: config }
            ]
        };
    }
}
